(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-template-new"]) return;
  try {
    

let selectors = {
    details: ".filters-new details",
}

let details = document.querySelectorAll(selectors.details)

details.forEach(detail => {
    detail.addEventListener("click", function(e){
      
      if ( !detail.querySelector(".filters-new__values").contains(e.target) ) {
         if(this.hasAttribute("open")) {
          setTimeout(() => {
            console.log("remove")
             this.removeAttribute("open")
          }, "60")
         } else {
          details.forEach(detail_check => {
            detail_check.removeAttribute("open")
          })
         }
      }
    })
});

document.addEventListener("click", function(ev){

  let filters_new = document.querySelector(".filters-new")

  if ( !filters_new.contains(ev.target) ) {
    details.forEach(detail => {
      detail.removeAttribute("open")
    })
  }


})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-template"]) return;
  try {
    

let selectors = {
    details: ".filters-new details",
}

let details = document.querySelectorAll(selectors.details)

details.forEach(detail => {
    detail.addEventListener("click", function(e){
      
      if ( !detail.querySelector(".filters-new__values").contains(e.target) ) {
         if(this.hasAttribute("open")) {
          setTimeout(() => {
            console.log("remove")
             this.removeAttribute("open")
          }, "60")
         } else {
          details.forEach(detail_check => {
            detail_check.removeAttribute("open")
          })
         }
      }
    })
});

document.addEventListener("click", function(ev){

  let filters_new = document.querySelector(".filters-new")

  if ( !filters_new.contains(ev.target) ) {
    details.forEach(detail => {
      detail.removeAttribute("open")
    })
  }


})



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template"]) return;
  try {
    
  
      (function(document) {
  
          /*let selectors = {
              productDescription: '.js-prod-description',
              readMore: '.js-read-more',
              readLess: '.js-read-less',
              dots: '.js-dots',
              colorCheckLabels: '.js-label-color-check',
              ColorSwatch__Radios: '.ColorSwatch__Radio',
  
              openModalPDP: '.js-open-modal-pdp',
              closeModalPDP: '.js-close-modal-pdp',
              modalPDP: '.js-modal-pdp',
              customTabTaglieTable: '.custom_tab_taglie_table',
              imgSizeCharts: '.js-img-size-chart',
          };
          
          let productDescription = document.querySelector(selectors.productDescription);
          let readMore = document.querySelector(selectors.readMore);
          let readLess = document.querySelector(selectors.readLess);
          let dots = document.querySelector(selectors.dots);*/
          let colorCheckLabels = document.querySelectorAll(selectors.colorCheckLabels);
          let ColorSwatch__Radios = document.querySelectorAll(selectors.ColorSwatch__Radios);
  
          let openModalPDP = document.querySelector(selectors.openModalPDP);
          let closeModalPDP = document.querySelector(selectors.closeModalPDP);
          let modalPDP = document.querySelector(selectors.modalPDP);
          let customTabTaglieTable = document.querySelector(selectors.customTabTaglieTable);
          let imgSizeCharts = document.querySelectorAll(selectors.imgSizeCharts);
  
  
          if (customTabTaglieTable) {
  
            imgSizeCharts.forEach(imgSizeChart => {
              if (imgSizeChart.getAttribute("data-size-type") == customTabTaglieTable.getAttribute("data-image-category")) {
                imgSizeChart.classList.add("show")
                
                openModalPDP.style.display = "block"
  
              } else {
                imgSizeChart.classList.remove("show")
              }
            })
  
          }
  
          if (openModalPDP) {
  
            openModalPDP.addEventListener("click", (e) => {
              modalPDP.classList.add("show")
            })
            closeModalPDP.addEventListener("click", (e) => {
              modalPDP.classList.remove("show")
            })
          }
  
  
          /*readMore.addEventListener("click", (e) => {
            productDescription.classList.add("open")
            dots.classList.add("hide")
            readLess.classList.remove("hide")
            readMore.classList.add("hide")
          })
          readLess.addEventListener("click", (e) => {
            productDescription.classList.remove("open")
            dots.classList.remove("hide")
            readLess.classList.add("hide")
            readMore.classList.remove("hide")
          })*/
  
          ColorSwatch__Radios.forEach(ColorSwatch__Radio => {
            ColorSwatch__Radio.addEventListener("change", function(event){
  
              var item = event.target.dataset.valueupcase;
  
              colorCheckLabels.forEach(colorCheckLabel => {
                if (colorCheckLabel.dataset.color == item ) {
                  colorCheckLabel.classList.add("selected")
                } else {
                  colorCheckLabel.classList.remove("selected")
                }
              });
            })
          });
  
      })(document);
  
  
  } catch(e) { console.error(e); }
})();
})();
